import { MapPin, Phone, ExternalLink, Globe } from "lucide-react";

const Footer = () => {
  return (
    <footer className="bg-slate-900 text-white py-12">
      <div className="max-w-6xl mx-auto px-6">
        <div className="grid md:grid-cols-3 gap-8">
          {/* Company Info */}
          <div>
            <h3 className="font-bold text-lg mb-4">White Sky Travel and Tourism LLC</h3>
            <p className="text-slate-400 text-sm mb-3">
              Your trusted partner for UAE visa services. Professional, reliable, and compliant.
            </p>
            <a
              href="https://whitesky.ae"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 text-sky-400 hover:text-sky-300 transition-colors text-sm font-medium"
              data-testid="footer-website"
            >
              <Globe className="w-4 h-4" />
              whitesky.ae
              <ExternalLink className="w-3 h-3" />
            </a>
          </div>
          
          {/* Contact */}
          <div>
            <h4 className="font-semibold mb-4">Contact Us</h4>
            <div className="space-y-3">
              <a 
                href="tel:+97142202133" 
                className="flex items-center gap-2 text-slate-400 hover:text-white transition-colors text-sm"
                data-testid="footer-phone-1"
              >
                <Phone className="w-4 h-4" />
                +971 4 220 2133
              </a>
              <a 
                href="tel:+971522921011" 
                className="flex items-center gap-2 text-slate-400 hover:text-white transition-colors text-sm"
                data-testid="footer-phone-2"
              >
                <Phone className="w-4 h-4" />
                +971 52 292 1011
              </a>
            </div>
          </div>
          
          {/* Location */}
          <div>
            <h4 className="font-semibold mb-4">Location</h4>
            <a 
              href="https://maps.app.goo.gl/ont1TtTi78ZZuUy9A"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-start gap-2 text-slate-400 hover:text-white transition-colors text-sm"
              data-testid="footer-location"
            >
              <MapPin className="w-4 h-4 mt-0.5 flex-shrink-0" />
              <span>Room 202 Royal Class Building, DIP 1, Dubai</span>
              <ExternalLink className="w-3 h-3 flex-shrink-0" />
            </a>
          </div>
        </div>
        
        <div className="border-t border-slate-800 mt-8 pt-8 text-center">
          <p className="text-slate-500 text-sm">
            © {new Date().getFullYear()} White Sky Travel and Tourism LLC. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
